import apiUrl from '../../../constants'
import commonFunction from '../../../commonFunction'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import JQuery from 'jquery'
let $ = JQuery

import tlDashoboard from './tlDashboard'
import agentdashboard from './agentdashboard'
import emailtracking from './emailtracking'

Vue.filter('formatDatesingle', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY HH:mm:ss')
  }
});

export default {
  name: 'emailr',
  components: {
    tlDashoboard,
    agentdashboard,
    emailtracking
  },
  data: function () {
    return {
      component:'',
      userRole:'',

    }
  },
  created: function () {
    [this.subDepartmentList, this.DepartmentID, this.userdetail, this.permissiondata, this.userTypeForTicket, this
      .SummarySelectOptionObj, this.SummaryOptionObj
    ] = commonFunction.getuserDetailsAndpermissionData();

    // console.log('userdetail : ' + JSON.stringify(this.userdetail));
    this.userid = this.userdetail[0].userid;
    this.username = this.userdetail[0].username;
    this.userRole = this.userdetail[0].roles[0].rolename;
    this.component = ( this.userRole.toLowerCase() == 'associate') ? "agentdashboard" : "tlDashoboard";
    // console.log('userRole : ' + this.userRole);
  },
  computed: {
    currentRoute:{
      get(){
          this.nombreRuta = this.$route.name;
      }
  }
  },

  mounted() {
    // console.log("this.DepartmentID====>",this.DepartmentID);
     if(this.DepartmentID !== 3 && this.DepartmentID !== 23){
       this.$router.push('/dashboard');
       this.$alertify.error('Please change department to Net Mail or Wallet Net Mail.');
       // return false;
     }

     
  },
  methods: {


  },
}



// WEBPACK FOOTER //
// ./src/views/components/emailr/emailr.component.js